/**
 * Wire contract for the admin orders LIST surface (AUT-112 /
 * PHASE-B-API-1):
 *
 *   - `GET /admin/orders` → `ListAdminOrdersResultDto`
 *
 * Centralised in `@carcheck/shared` so the api + admin SPA import the
 * same source of truth — no api↔admin mirror drift.
 *
 * PII discipline (architect lock — AUT-112): the `customerName` /
 * `customerPhone` / `inspectorName` fields carry REDACTED values
 * (`+375••••••67`, `И. Д••`) when the calling admin lacks the `view_pii`
 * permission. The `piiRevealed` flag tells the SPA which variant it
 * received so it never re-redacts a full value or renders a redacted
 * value as copyable. The server is the sole authority on redaction.
 *
 * All `Date` fields are ISO-8601 strings (JSON has no `Date`); consumers
 * convert at the render boundary via `new Date(dto.createdAt)`.
 */
/**
 * Admin-facing order status — the FULL 11-state internal lifecycle (NOT
 * the user-facing 7-state wire enum in `order-status.ts`). The admin
 * console surfaces every granular state so an operator can triage. Mirror
 * of Prisma `OrderStatus`; kept here so the SPA avoids `@prisma/client`.
 *
 * Single source of truth for the api's filter Zod schema too — the api
 * imports `ADMIN_ORDER_STATUSES` rather than hand-typing the 11 values.
 */
export const ADMIN_ORDER_STATUSES = [
    'draft',
    'awaiting_payment',
    'paid',
    'accepted',
    'in_progress',
    'report_submitted',
    'completed',
    'released',
    'disputed',
    'cancelled',
    'expired',
];
//# sourceMappingURL=admin-order-list.js.map